module.exports = __webpack_public_path__ + "img/house-blue.2a3de562.svg";